import { render } from "./New.vue?vue&type=template&id=d34490f4&scoped=true"
import script from "./New.vue?vue&type=script&lang=js"
export * from "./New.vue?vue&type=script&lang=js"

import "./New.vue?vue&type=style&index=0&id=d34490f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d34490f4"

export default script